import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useCart } from '../contexts/CartContext';
const snacks = [{
  id: 'snack-1',
  name: 'Chicken Patty',
  desc: 'Savory pastry filled with seasoned minced chicken.',
  price: '$3.00',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/meat-pie.jpg?fit=1024%2C576&ssl=1',
  emoji: '🍗'
}, {
  id: 'snack-2',
  name: 'Tilapia Fish',
  desc: 'Crispy fried tilapia fish seasoned with traditional spices.',
  price: '$3.00',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/download-2-scaled.jpg?fit=1920%2C1280&ssl=1',
  emoji: '🐟'
}, {
  id: 'snack-3',
  name: 'Side of Veggies',
  desc: 'Fresh mixed vegetables prepared with light seasoning.',
  price: '$5.00',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/veggies.jpeg?fit=116%2C87&ssl=1',
  emoji: '🥗'
}, {
  id: 'snack-4',
  name: 'Plantain',
  desc: 'Sweet fried plantain slices, golden and caramelized.',
  price: '$5.00',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/fried-plantains-150x150-1.jpg?fit=150%2C150&ssl=1',
  emoji: '🍌'
}, {
  id: 'snack-5',
  name: 'Moin Moin',
  desc: 'Steamed bean pudding made from blended black-eyed peas.',
  price: '$3.50',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/moimoi.jpg?fit=116%2C87&ssl=1',
  emoji: '🥮'
}, {
  id: 'snack-6',
  name: 'Coconut Bread',
  desc: 'Soft, sweet bread baked with fresh coconut flakes.',
  price: '$1.99',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/coconut-bread.jpeg?fit=116%2C87&ssl=1',
  emoji: '🥥'
}, {
  id: 'snack-7',
  name: 'Spinach',
  desc: 'Sautéed fresh spinach with onions and seasoning.',
  price: '$5.00',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/spinach.jpg?fit=640%2C427&ssl=1',
  emoji: '🥬'
}, {
  id: 'snack-8',
  name: 'Jollof Rice (Extra)',
  desc: 'Extra portion of our signature jollof rice.',
  price: '$5.00',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/jrice-extra.jpeg?fit=116%2C87&ssl=1',
  emoji: '🍛'
}, {
  id: 'snack-9',
  name: 'White Rice (Extra)',
  desc: 'Extra portion of steamed white rice.',
  price: '$4.00',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/white-rice.jpg?fit=116%2C87&ssl=1',
  emoji: '🍚'
}, {
  id: 'snack-10',
  name: 'Salad',
  desc: 'Fresh garden salad with crisp vegetables and light dressing.',
  price: '$5.00',
  image: 'https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/salad-1.jpg?fit=116%2C87&ssl=1',
  emoji: '🥗'
}];
interface SnacksPageProps {
  onNavigate: (page: string) => void;
}
export function SnacksPage({
  onNavigate
}: SnacksPageProps) {
  const {
    addToCart
  } = useCart();
  const [addedId, setAddedId] = useState<string | null>(null);
  const handleAdd = (item: any) => {
    addToCart({
      id: item.id,
      name: item.name,
      price: parseFloat(item.price.replace('$', '')),
      emoji: item.emoji,
      image: item.image
    });
    setAddedId(item.id);
    setTimeout(() => setAddedId(null), 1200);
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="min-h-screen bg-cream pb-20" data-id="element-659">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12" data-id="element-660">
        <button onClick={() => onNavigate('menu')} className="mb-8 font-heading text-charcoal/60 hover:text-charcoal uppercase tracking-wider transition-colors" data-id="element-661">
          ← Back to Full Menu
        </button>

        <h1 className="font-heading text-5xl md:text-6xl text-charcoal uppercase tracking-wide mb-4 text-center" data-id="element-662">
          Sides & <span className="text-amber" data-id="element-663">Extras</span>
        </h1>
        <p className="text-center font-body text-charcoal/70 max-w-2xl mx-auto mb-12" data-id="element-664">
          Perfect additions to complete your meal.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-665">
          {snacks.map((item, i) => <motion.div key={item.id} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-6 shadow-lg border border-amber/10 flex flex-col group" data-id="element-666">
              <div className="h-48 bg-cream rounded-xl flex items-center justify-center mb-6 overflow-hidden" data-id="element-667">
                {item.image ? <img src={item.image} alt={item.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-668" /> : <span className="text-5xl drop-shadow-md" data-id="element-669">{item.emoji}</span>}
              </div>
              <h3 className="font-heading text-2xl uppercase text-charcoal mb-2" data-id="element-670">
                {item.name}
              </h3>
              <p className="font-body text-charcoal/60 mb-6 flex-grow text-sm" data-id="element-671">
                {item.desc}
              </p>
              <div className="flex justify-between items-center mt-auto pt-4 border-t border-charcoal/5" data-id="element-672">
                <span className="font-heading text-3xl text-victory-red" data-id="element-673">
                  {item.price}
                </span>
                <button onClick={() => handleAdd(item)} className={`px-4 py-2 rounded-lg font-heading uppercase text-sm transition-colors active:scale-95 ${addedId === item.id ? 'bg-green-600 text-white' : 'bg-charcoal text-white hover:bg-amber'}`} data-id="element-674">
                  {addedId === item.id ? 'Added ✓' : 'Add to Order'}
                </button>
              </div>
            </motion.div>)}
        </div>
      </div>
    </motion.div>;
}